<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>{{ TitleText }}</h1>
    <div fxFlex class="scroll">
        <p [innerHTML]="MessageText | safeHTML"></p>
        <div *ngIf="HasDesigneeEntries">
            <strong>Note: </strong>Entries in the list provided that bear the <mat-icon>account_circle</mat-icon> icon indicate entries
            that you are viewing because a cabinet member has designated you as an "Out of Office" designee for the request.
        </div>
        <table mat-table #table [dataSource]="DetailsData" class="fullwidth">
            <!-- As Designee Column -->
            <ng-container matColumnDef="AsDesignee">
                <th mat-header-cell *matHeaderCellDef class="centered"></th>
                <td mat-cell *matCellDef="let item" class="centered">
                    <mat-icon *ngIf="item.AsDesignee" title="Referral is a cabinet member designee entry.">account_circle</mat-icon>
                </td>
            </ng-container>

            <!-- Request Number Column -->
            <ng-container matColumnDef="RequestIssueNumber">
                <th mat-header-cell *matHeaderCellDef class="centered">Request Number</th>
                <td mat-cell *matCellDef="let item" class="centered">{{ item.RequestIssueNumber }}</td>
            </ng-container>

            <!-- Request Subject Column -->
            <ng-container matColumnDef="Subject">
                <th mat-header-cell *matHeaderCellDef class="centered">Subject</th>
                <td mat-cell *matCellDef="let item" class="centered">{{ item.Subject }}</td>
            </ng-container>

            <!-- Board Member Column -->
            <ng-container matColumnDef="BoardMember">
                <th mat-header-cell *matHeaderCellDef class="centered">Board Member</th>
                <td mat-cell *matCellDef="let item" class="centered">
                    {{ item.RequestorInfo?.FirstName | titleCase }} {{ item.RequestorInfo?.LastName | titleCase }}
                </td>
            </ng-container>

            <!-- Date Referred Column -->
            <ng-container matColumnDef="DateReferred">
                <th mat-header-cell *matHeaderCellDef class="centered">Date Referred</th>
                <td mat-cell *matCellDef="let item" class="centered">{{ item.DateReferred | date: 'M/d/yyyy' }}</td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="RequestStatus">
                <th mat-header-cell *matHeaderCellDef class="centered">Status</th>
                <td mat-cell *matCellDef="let item" class="centered">
                    {{ item.RequestStatus | referralStatus: AsBoard:item.Completed }}
                </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="Actions">
                <th mat-header-cell *matHeaderCellDef class="centered">Action(s)</th>
                <td mat-cell *matCellDef="let item" class="centered">
                    <button type="button" mat-raised-button color="primary" (click)="ViewReferral(item)">View</button>
                </td>
            </ng-container>

            <ng-container matColumnDef="SmallDisplay">
                <th mat-header-cell *matHeaderCellDef class="centered">Notification(s)</th>
                <td mat-cell *matCellDef="let item">
                    <div fxLayout="column" fxLayoutAlign="start stretch">
                        <div fxLayout="row" fxLayoutAlign="space-between start">
                            <div fxLayout="row" fxLayoutAlign="start start">
                                <mat-icon *ngIf="item.AsDesignee" title="Referral is a cabinet member designee entry."
                                    >account_circle</mat-icon
                                >
                                <app-form-label>Request #</app-form-label>
                            </div>
                            <div>{{ item.RequestIssueNumber }}</div>
                        </div>
                        <div *ngIf="!AsBoard" fxLayout="row" fxLayoutAlign="space-between start">
                            <app-form-label>Board Member</app-form-label>
                            <div>{{ item.RequestorInfo?.FirstName | titleCase }} {{ item.RequestorInfo?.LastName | titleCase }}</div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between start">
                            <app-form-label>Subject</app-form-label>
                            <div>{{ item.Subject }}</div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between start">
                            <app-form-label>Date Referred</app-form-label>
                            <div>{{ item.DateReferred | date: 'M/d/yyyy' }}</div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between start">
                            <app-form-label>Status</app-form-label>
                            <div>{{ item.Status | referralStatus: AsBoard:item.Completed }}</div>
                        </div>
                        <div class="actionbar" fxLayout="column" fxLayoutAlign="start center">
                            <button type="button" mat-raised-button color="primary" (click)="ViewReferral(item)">View</button>
                        </div>
                    </div>
                </td>
            </ng-container>

            <!-- Table contents -->
            <tr mat-header-row *matHeaderRowDef="VisibleHeaders"></tr>
            <tr mat-row *matRowDef="let row; columns: VisibleColumns"></tr>
        </table>
    </div>
    <div class="bottomactionbar" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" fxLayoutAlign.lt-md="center center">
        <button mat-raised-button color="primary" (click)="OKHandler()">OK</button>
    </div>
</div>
